import React from 'react'
import { useNavigate } from 'react-router-dom'
import CivilWorkCard from './CivilWorkCard'
import { Bar, Pie } from 'react-chartjs-2'
import { Pieoptions, WorkAssign } from '../../../../../Helper/Data'

export default function CivilWorkCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props
    const navigate = useNavigate()

    const CivilWorkCardNavigate = (name, screenFlag) => {
        navigate(`/WorkAssignedDMCTable?name=${name}&ApiFlag=JR&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)

        // if (name === "Pending") {
        //     navigate(`/gardenworkpending?name=${name}&ApiFlag=Pending&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        // } 
        // else if (name === "Completed") {
        //     navigate(`/gardenworkpending?name=${name}&ApiFlag=Completed&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        // }
    }

    const Targetdata = {
        labels: ['Junior Engineer '],
        datasets: [
            {
                // label: "Pending",
                fill: true,
                backgroundColor: [
                    "#cc2836",
                ],
                height: [
                    "10em"
                ],
                data: [
                    Countdata && Countdata?.UploadAssignWork_Jr_TotalCount,
                    // 0
                ]
            },
            // {
            //     label: "Completed",
            //     fill: true,
            //     backgroundColor: [
            //         "#FFB300",
            //         "#FFB300",
            //         "#FFB300",
            //         "#FFB300"
            //     ],
            //     data: [5, 1, 2, 2]
            // },
            // {
            //     label: "Reopen Pending",
            //     fill: true,
            //     backgroundColor: [
            //         "#253150",
            //         "#253150",
            //         "#253150",
            //         "#253150"
            //     ],
            //     data: [4, 5, 6, 3]
            // }

        ],
    };

    return (
        <div className='row m-1 p-0  bg-white mx-0'>
            <h5 className=" pt-2 mb-0 ">Civil Work Assign By Officials</h5>
            <div className='m-0' > <hr className="mt-2"style={{ color: "#a3964e" }}></hr></div>

            <div className="col-12 col-lg-7  p-0">
                <div className="row pb-3 pb-lg-0 ps-lg-3 px-2" >

                    <div className="col-12 col-md-6 col-lg-6 " >
                        <CivilWorkCard
                            title="Junior Engineer"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/civilengineers.png'
                            count={Countdata.UploadAssignWork_Jr_TotalCount ? Countdata.UploadAssignWork_Jr_TotalCount : '0'}
                            // count='0'
                            // navLink='/gardenworkpending'
                            CivilWorkCardNavigate={CivilWorkCardNavigate}
                        />
                    </div>
                    {/* <div className="col-12 col-md-6 col-lg-6 mb-2">
                    <GardenDailyWorkCard
                        title="Completed"
                        cardName='py-2 wwork_img cursor'
                        imgPath='./assets/img/completed1.png'
                        count={Countdata.PreventiveCompletedTotalCount ? Countdata.PreventiveCompletedTotalCount : '0'}
                        // navLink='/gardenworkcomplete'
                        DailyPreventiveWorkNavigate={DailyPreventiveWorkNavigate}
                    />
                </div> */}
                </div>
            </div>
            <div className="col-12 col-lg-5   px-1">
                {/* <div className="row ">
                    <div className="col-12 ">
                        <div className=" px-3 pb-0 upload_chart bg-white ">
                            <div className="row d-flex justify-content-center align-items-center "> */}
                <div className=" rounded-4 shadow-sm p-3 pt-2 mt-0 h-100 Chartborder ">

                        <div className="d-flex justify-content-center align-items-center h-100 ">
                {
                    (Countdata?.UploadAssignWork_Jr_TotalCount != 0) ?
                        <Bar
                            height={80}
                            // width={100}
                            options={WorkAssign}
                            data={Targetdata}
                        />
                        :
                       <div className='text-danger  my-auto align-item-center  justify-content-center fw-bolder' style={{ height: '7vh' , }}>
                                    <img
                                        className='wwork_img me-3'
                                        src="../assets/img/bar-graph.png"
                                    />
                                  <span className=''>No Data Found</span>  
                                </div>
                }
                {/* </div>
                        </div>
                    </div>
                </div> */}
            </div>
        </div>
            </div>
        </div>


    )

}

